import { render, staticRenderFns } from "./addElectronicFence.vue?vue&type=template&id=cb0daac2&"
import script from "./addElectronicFence.vue?vue&type=script&lang=js&"
export * from "./addElectronicFence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports